export const SPECIALIZED_TERMINALS = [
  {
    slug: 'placeholder',
    routeName: 'PlaceholderTerminal',
    displayName: 'Placeholder Terminal',
    permission: 'can_use_placeholder_terminal',
    component: () => import('./_placeholder/Terminal.vue'),
    icon: 'fa-wrench'
  },
  {
    slug: 'ach-batch',
    routeName: 'AchBatchTerminal',
    displayName: 'ACH Batch',
    permission: 'can_use_ach_batch_terminal',
    component: () => import('./achBatch/Terminal.vue'),
    icon: 'fa-random'
  }
]



// WEBPACK FOOTER //
// ./src/components/terminal/specialized/index.js